import _ from 'lodash';
import { makeRequestWithRetry } from 'src/utils/graphql';
import { ArticleEntity } from 'src/modules/articles';
import { QUERY_REFERENCES_DETAILS, QUERY_RELATED_REFERENCES_DETAILS } from '../queries';
import { ProfessionalsReferencesDetailsActions } from './types';
import { ReferenceEntity } from 'src/modules/professionals';

export const fetchReferencesDetailsData = async (slug: string) => {
  const response = await makeRequestWithRetry<{ articles: ArticleEntity[] }>(
    QUERY_REFERENCES_DETAILS,
    { slug },
    { errorId: 'fetchReferencesDetailsData()' }
  );

  return response;
};

export const fetchRelatedReferencesDetailsData = async (
  categoryId: string,
  referenceId: string
) => {
  const response = await makeRequestWithRetry<{
    references: ReferenceEntity[];
    pagination: boolean;
  }>(
    QUERY_RELATED_REFERENCES_DETAILS,
    { categoryId },
    { errorId: 'fetchRelatedReferencesDetailsData()' }
  );

  const references = _.chain(response?.references)
    .filter((ref) => ref.article.id !== referenceId)
    .slice(0, 3)
    .value();

  return { ...response, references };
};

const { FetchDetailsSuccess } = ProfessionalsReferencesDetailsActions;

export const fetchReferencesDetailsDataSuccess = (results: any) => ({
  type: FetchDetailsSuccess,
  payload: results,
});
